<script>
import LkpmStatistik from '@/components/dashboard/lkpm/Statistik.vue'
import LkpmUmkChart from '@/components/dashboard/lkpm/UmkChart.vue'
import LkpmUmkStatus from '@/components/dashboard/lkpm/UmkStatus.vue'
import LkpmUmkKbli from '@/components/dashboard/lkpm/UmkKbli.vue'
import LkpmUmkSektor from '@/components/dashboard/lkpm/UmkSektor.vue'
import LkpmNonUmkChart from '@/components/dashboard/lkpm/NonUmkChart.vue'
import LkpmNonUmkStatus from '@/components/dashboard/lkpm/NonUmkStatus.vue'
import LkpmNonUmkKbli from '@/components/dashboard/lkpm/NonUmkKbli.vue'
import LkpmNonUmkSektor from '@/components/dashboard/lkpm/NonUmkSektor.vue'

export default {
   components: {
      LkpmStatistik,
      LkpmUmkChart,
      LkpmUmkStatus,
      LkpmUmkKbli,
      LkpmUmkSektor,
      LkpmNonUmkChart,
      LkpmNonUmkStatus,
      LkpmNonUmkKbli,
      LkpmNonUmkSektor,
   },
}
</script>

<template>
   <div>
      <LkpmStatistik />

      <b-row class="mt-1">
         <b-col cols="12" md="6" class="mb-1">
            <LkpmNonUmkChart class="mt-1" />

         </b-col>
         <b-col cols="12" md="6" class="mb-1">
            <LkpmUmkChart class="mt-1" />

         </b-col>
      </b-row>

      <b-row class="mt-1">
         <b-col cols="12" md="6" class="mb-1">
            <LkpmNonUmkStatus class="mt-1" />
         </b-col>
         <b-col cols="12" md="6" class="mb-1">
            <LkpmUmkStatus class="mt-1" />
         </b-col>
      </b-row>

      <b-row class="mt-1">
         <b-col cols="12" md="6" class="mb-1">
            <LkpmNonUmkKbli />
         </b-col>
         <b-col cols="12" md="6" class="mb-1">
            <LkpmNonUmkSektor />
         </b-col>
      </b-row>
      <b-row class="mt-1">
         <b-col cols="12" md="6" class="mb-1">
            <LkpmUmkKbli />
         </b-col>
         <b-col cols="12" md="6" class="mb-1">
            <LkpmUmkSektor />
         </b-col>
      </b-row>
   </div>
</template>

<style scoped></style>
